import { render, staticRenderFns } from "./video_bodyless.vue?vue&type=template&id=1cd28d03&"
import script from "./video_bodyless.vue?vue&type=script&lang=js&"
export * from "./video_bodyless.vue?vue&type=script&lang=js&"
import style0 from "./video_bodyless.vue?vue&type=style&index=0&lang=css&"
import style1 from "./video_bodyless.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "video_bodyless.vue"
export default component.exports